import React from 'react';
import KogInputTextOutlinedControlled from '@/main/components/shared/inputText/inputTextOutlinedControlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { getTranslateByKey } from '@/main/services/utils';
import { QuoteSupplierItemPartResponse } from '@/main/models/response';

interface IPartNumberInputProps {
  fieldPrefix: string;
  showFieldWithouEdit?: boolean;
  row: QuoteSupplierItemPartResponse;
}

export default function ColumnSku({ fieldPrefix, showFieldWithouEdit, row }: IPartNumberInputProps) {
  const { control } = useFormContext();

  const watcherNotQuote = useWatch({
    control,
    name: `${fieldPrefix}.notQuote`,
    defaultValue: false
  });

  if (row.isInventoryResponse || showFieldWithouEdit) {
    return <>{row.partNumber}</>;
  }

  return (
    <KogInputTextOutlinedControlled
      name={`${fieldPrefix}.partNumber`}
      placeholder={getTranslateByKey('information.sku')}
      id="id-createAnswer-txt-partNumber"
      label=""
      disabledMessage
      control={control}
      hideValue={watcherNotQuote}
      inputProps={{ maxLength: 50 }}
      disabled={watcherNotQuote}
      controllerProps={{
        rules: {
          required: false,
          maxLength: 50
        }
      }}
    />
  );
}
